import {
  Button,
  Card,
  Col,
  Form,
  Input,
  Row,
  Select,
  Space,
  Typography,
} from "antd";
import { InboxOutlined, DownloadOutlined } from "@ant-design/icons";
import Dragger from "antd/es/upload/Dragger";
import { useState } from "react";
import { useForm } from "antd/es/form/Form";
import { BASE_URL } from "../../api/Constants";
import Meta from "antd/es/card/Meta";

const { Title, Text } = Typography;

const FormColletion = (props) => {
  const { onFinish, errorMsg, initialValues, pubHouse, type, collection } =
    props;

  const [form] = useForm();
  const [headerLis, setHeaderList] = useState([]);
  const [coverList, setCoverList] = useState([]);
  const [errMsgCover, setErrMsgCover] = useState("");

  const handleHeaderChange = ({ fileList: newFileList }) =>
    setHeaderList(newFileList);
  const handleCoverChange = ({ fileList: newFileList }) =>
    setCoverList(newFileList);

  const checkFile = (file) => {
    setErrMsgCover("");
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
      setErrMsgCover("You can only upload JPG/PNG file!");
      return false;
    }
    const isLt2M = file.size / 1024 / 1024 < 1;
    if (!isLt2M) {
      setErrMsgCover("Image must be smaller than 1MB!");
      return false;
    }

    return true;
  };

  const checkFileName = (file) => {
    if (!file.name.includes("header")) {
      setErrMsgCover("Le nom du fichier doit être 'header-[...].png'!");
      return false;
    }
    return checkFile(file);
  };

  return (
    <>
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        initialValues={initialValues}
      >
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Maison d'édition"
              name="pubHouseName"
              rules={[
                { required: true, message: "Choisir une maison d'édition" },
              ]}
            >
              <Select
                showSearch
                placeholder="Rechercher une maison d'édition"
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                filterSort={(optionA, optionB) =>
                  (optionA?.label ?? "")
                    .toLowerCase()
                    .localeCompare((optionB?.label ?? "").toLowerCase())
                }
                options={pubHouse.map((c) => {
                  return { label: c.name, value: c.name };
                })}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Statut de la collection" name="collectionState">
              <Select
                options={[
                  { value: "free", label: "Gratuit" },
                  { value: "admin", label: "Administrateur" },
                  { value: "subscribed", label: "Abonné" },
                ]}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Nom de la collection"
              name="collectionName"
              rules={[
                { required: true, message: "Choisir un nom de collection" },
              ]}
            >
              <Input placeholder="Lulu à Brest" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="UID Collection"
              name="uidCollection"
              rules={[{ required: true, message: "Insérer un UID valide" }]}
            >
              <Input
                placeholder="UID_COLLECTION"
                disabled={type === "update"}
              />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item wrapperCol={{ span: 16 }}>
          <Button type="primary" htmlType="submit">
            Enregistrer
          </Button>
        </Form.Item>
        <Text type="danger">{errorMsg}</Text>
      </Form>
      {type === "update" ? (
        <>
          <Row gutter={16}>
            <Col span={12}>
              <Title level={4}>Image d'en-tête</Title>
              <Dragger
                height={100}
                style={{ marginBottom: 15 }}
                action={`${BASE_URL}/collection/${initialValues.uidCollection}/cover`}
                withCredentials={true}
                listType="picture"
                multiple
                fileList={headerLis}
                onChange={handleHeaderChange}
                beforeUpload={checkFileName}
              >
                <p className="ant-upload-drag-icon">
                  <InboxOutlined />
                </p>
              </Dragger>
              <Text type="danger">{errMsgCover}</Text>
              <Space wrap>
                <Card
                  key={collection.imgHeader}
                  hoverable
                  style={{ width: 240 }}
                  cover={
                    <img
                      alt="example"
                      src={`https://newbrand.s3.eu-west-3.amazonaws.com/collections/${collection.uid}/headers/${collection.imgHeader}`}
                    />
                  }
                  actions={[
                    <a
                      key="downloadCover"
                      download
                      href={`https://newbrand.s3.eu-west-3.amazonaws.com/collections/${collection.uid}/${collection.imgCollection}`}
                      title="image header"
                    >
                      <DownloadOutlined />
                    </a>,
                  ]}
                >
                  <Meta description={collection.imgHeader} />
                </Card>
              </Space>
            </Col>
            <Col span={12}>
              <Title level={4}>Image de couverture</Title>
              <Dragger
                height={100}
                style={{
                  marginBottom: 15,
                }}
                action={`${BASE_URL}/collection/${initialValues.uidCollection}/cover`}
                withCredentials={true}
                listType="picture"
                multiple
                fileList={coverList}
                onChange={handleCoverChange}
                beforeUpload={checkFile}
              >
                <p className="ant-upload-drag-icon">
                  <InboxOutlined />
                </p>
              </Dragger>
              <Text type="danger">{errMsgCover}</Text>
              <Space wrap>
                <Card
                  key={collection.imgCollection}
                  hoverable
                  style={{ width: 240 }}
                  cover={
                    <img
                      alt="example"
                      src={`https://newbrand.s3.eu-west-3.amazonaws.com/collections/${collection.uid}/${collection.imgCollection}`}
                    />
                  }
                  actions={[
                    <a
                      key="downloadCover"
                      download
                      href={`https://newbrand.s3.eu-west-3.amazonaws.com/collections/${collection.uid}/${collection.imgCollection}`}
                      title="image collection"
                    >
                      <DownloadOutlined />
                    </a>,
                  ]}
                >
                  <Meta description={collection.imgCollection} />
                </Card>
              </Space>
            </Col>
          </Row>
        </>
      ) : null}
    </>
  );
};

export default FormColletion;
